"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Create Data Record',
    description: 'Create a new data record in a collection',
});
//# sourceMappingURL=create-data-record.js.map